import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  htmlFor: '',
  className: '',
};

const Label = ({ className, children, htmlFor, optional, ...props }) => (
  <label
    htmlFor={htmlFor || null}
    className={clsx(`block text-gray-700 mb-1 pointer font-medium`, className)}
    {...props}
  >
    {children}

    {optional && (
      <span className="text-gray-600 font-normal text-sm italic ml-2">
        optional
      </span>
    )}
  </label>
);

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;
